import { INTERACTIONS } from '../constants/Constants';
import { InteractionUnlock } from '../display/InteractionUnlock';

export default class InteractionBase extends Phaser.Scene {
  constructor(id) {
    super({ active: false });
    this.interactionId = id;
  }

  endInteraction(data) {
    this.tweens.killAll();
    this.time.removeAllEvents();
    this.game.vo.stop();

    if (this.interactionId) {
      const hasUnlockedToyboxItem = this.game.player.hasToyBoxItem(this.interactionId);
      if (!hasUnlockedToyboxItem) {
        this.game.player.addToToybox(this.interactionId);
        const unlock = new InteractionUnlock(
          this,
          INTERACTIONS.find((i) => i.id === this.interactionId)
        );
        unlock.toybox.once('open', () => this._clearScene(unlock), this);
        unlock.once('complete', () => this._closeScene(data));
      } else this._closeScene(data);
    } else this._closeScene(data);
  }

  _clearScene(ignore) {
    this.children.list.forEach((c) => {
      if (c != ignore) {
        c.visible = false;
        c.destroy();
      }
    });
  }

  _closeScene(data) {
    this.cameras.main.once(
      'camerafadeoutcomplete',
      () => {
        this.events.emit('complete', data);
        this.scene.stop();
        this.scene.sendToBack();
      },
      this
    );
    this.cameras.main.fadeOut(500, 125, 205, 235);
  }
}
